// Fixed UI text only; backend content retains per-field fallback.
export const accountDict: { en: Record<string, string>; ar: Record<string, string> } = {
  "en": {
    "auth.please_enter_a_valid_email_address": "Please enter a valid email address.",
    "auth.password_must_be_at_least_6_characters": "Password must be at least 6 characters.",
    "auth.full_name_is_required": "Full name is required",
    "auth.passwords_do_not_match": "Passwords do not match",
    "auth.email_or_password_is_incorrect_please_check_your_credentials_and_try_again": "Email or password is incorrect. Please check your credentials and try again.",
    "auth.please_verify_your_email_address_before_signing_in": "Please verify your email address before signing in.",
    "auth.login_failed": "Login Failed",
    "auth.please_check_your_email_and_password": "Please check your email and password.",
    "auth.welcome_back": "Welcome back!",
    "auth.you_have_successfully_logged_in": "You have successfully logged in.",
    "auth.this_email_is_already_registered_please_sign_in_instead": "This email is already registered. Please sign in instead.",
    "auth.signup_failed": "Signup Failed",
    "auth.account_created": "Account Created!",
    "auth.welcome_to_anaya_your_account_has_been_created_successfully": "Welcome to Anaya! Your account has been created successfully.",
    "auth.google_sign_in_failed": "Google Sign-In Failed",
    "auth.error": "Error",
    "auth.an_unexpected_error_occurred_please_try_again": "An unexpected error occurred. Please try again.",
    "auth.invalid_email": "Invalid Email",
    "auth.reset_link_sent": "Reset Link Sent",
    "auth.check_your_email_for_a_password_reset_link": "Check your email for a password reset link.",
    "auth.invalid_password": "Invalid Password",
    "auth.passwords_don_t_match": "Passwords Don't Match",
    "auth.please_make_sure_both_passwords_match": "Please make sure both passwords match.",
    "auth.password_updated": "Password Updated",
    "auth.your_password_has_been_updated_successfully": "Your password has been updated successfully.",
    "auth.loading": "Loading...",
    "auth.back_to_home": "Back to Home",
    "auth.anaya": "Anaya",
    "auth.reset_password": "Reset Password",
    "auth.enter_your_new_password_below": "Enter your new password below",
    "auth.new_password": "New Password",
    "auth.confirm_password": "Confirm Password",
    "auth.updating": "Updating...",
    "auth.update_password": "Update Password",
    "auth.back_to_login": "Back to Login",
    "auth.forgot_password": "Forgot password?",
    "auth.check_your_email_for_a_reset_link": "Check your email for a reset link",
    "auth.enter_your_email_and_we_ll_send_you_a_reset_link": "Enter your email and we'll send you a reset link",
    "auth.email_address": "Email Address",
    "auth.sending": "Sending...",
    "auth.send_reset_link": "Send Reset Link",
    "auth.welcome": "Welcome",
    "auth.sign_in_to_your_account_or_create_a_new_one": "Sign in to your account or create a new one",
    "auth.sign_in": "Sign in",
    "auth.sign_up": "Sign up",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.signing_in": "Signing in...",
    "auth.or_continue_with": "or continue with",
    "auth.sign_in_with_google": "Sign in with Google",
    "auth.don_t_have_an_account": "Don't have an account?",
    "auth.full_name": "Full Name",
    "auth.john_doe": "John Doe",
    "auth.creating_account": "Creating account...",
    "auth.create_account": "Create Account",
    "auth.signing_up": "Signing up...",
    "auth.sign_up_with_google": "Sign up with Google",
    "auth.already_have_an_account": "Already have an account?",
    "account.error": "Error",
    "account.verification_email_sent": "Verification Email Sent",
    "account.please_check_your_inbox_and_click_the_verification_link": "Please check your inbox and click the verification link.",
    "account.invalid_phone_number": "Invalid Phone Number",
    "account.failed_to_update_profile": "Failed to update profile",
    "account.profile_updated": "Profile Updated",
    "account.your_profile_has_been_updated_successfully": "Your profile has been updated successfully.",
    "account.failed_to_save_address": "Failed to save address",
    "account.address_updated": "Address Updated",
    "account.address_added": "Address Added",
    "account.your_address_has_been_saved_successfully": "Your address has been saved successfully.",
    "account.failed_to_delete_address": "Failed to delete address",
    "account.address_deleted": "Address Deleted",
    "account.the_address_has_been_removed": "The address has been removed.",
    "account.default_address_set": "Default Address Set",
    "account.this_address_will_be_used_for_new_orders": "This address will be used for new orders.",
    "account.failed_to_cancel_order_please_contact_support": "Failed to cancel order. Please contact support.",
    "account.cannot_cancel": "Cannot Cancel",
    "account.this_order_cannot_be_cancelled_it_may_have_already_been_processed": "This order cannot be cancelled. It may have already been processed.",
    "account.order_cancelled": "Order Cancelled",
    "account.your_order_has_been_cancelled_successfully": "Your order has been cancelled successfully.",
    "account.failed_to_generate_invoice_please_try_again": "Failed to generate invoice. Please try again.",
    "account.custom_perfume": "Custom Perfume",
    "account.loading": "Loading...",
    "account.close_account_page": "Close account page",
    "account.my_account": "My Account",
    "account.sign_out": "Sign Out",
    "account.create_your_perfume": "Create Your Perfume",
    "account.anaya_exclusive_collection": "Anaya Exclusive Collection",
    "account.profile": "Profile",
    "account.orders": "Orders",
    "account.addresses": "Addresses",
    "account.invoices": "Invoices",
    "account.wishlist": "Wishlist",
    "account.returns": "Returns",
    "account.profile_information": "Profile Information",
    "account.manage_your_personal_details": "Manage your personal details",
    "account.edit": "Edit",
    "account.full_name": "Full Name",
    "account.your_full_name": "Your full name",
    "account.country": "Country",
    "account.select_country": "Select country",
    "account.phone_number": "Phone Number",
    "account.save_changes": "Save Changes",
    "account.cancel": "Cancel",
    "account.not_set": "Not set",
    "account.email": "Email",
    "account.phone": "Phone",
    "account.status": "Status",
    "account.ticket_credits": "Ticket Credits",
    "account.each_ticket_net_amount_paid_for_accessory": "Each ticket = net amount paid for accessory",
    "account.available_tickets": "Available Tickets",
    "account.ticket": "ticket",
    "account.total_aed": "Total: AED",
    "account.redeem_at_checkout": "Redeem at checkout",
    "account.1_ticket_per_item": "(1 ticket per item)",
    "account.hide_ticket_details": "Hide Ticket Details",
    "account.view_ticket_details": "View Ticket Details",
    "account.recent_transactions": "Recent Transactions",
    "account.1_ticket": " (1 ticket)",
    "account.accessory_purchase": "Accessory purchase",
    "account.ticket_redeemed": "Ticket redeemed",
    "account.password": "Password",
    "account.change_your_account_password": "Change your account password",
    "account.change_password": "Change Password",
    "account.new_password": "New Password",
    "account.enter_new_password_min_6_characters": "Enter new password (min 6 characters)",
    "account.confirm_new_password": "Confirm new password",
    "account.invalid_password": "Invalid Password",
    "account.password_must_be_at_least_6_characters": "Password must be at least 6 characters",
    "account.passwords_don_t_match": "Passwords Don't Match",
    "account.please_make_sure_both_passwords_match": "Please make sure both passwords match",
    "account.password_updated": "Password Updated",
    "account.your_password_has_been_changed_successfully": "Your password has been changed successfully",
    "account.updating": "Updating...",
    "account.update_password": "Update Password",
    "account.active_orders": "Active Orders",
    "account.track_your_current_orders": "Track your current orders",
    "account.placed_on": "Placed on",
    "account.anaya_collection": "Anaya Collection",
    "account.your_ai_crafted_collection": "Your AI-Crafted Collection",
    "account.code": "Code:",
    "account.view_details": "View Details",
    "account.reorder": "Reorder",
    "account.return": "Return",
    "account.cancel_order": "Cancel Order",
    "account.keep_order": "Keep Order",
    "account.order_history": "Order History",
    "account.view_all_your_past_orders": "View all your past orders",
    "account.no_orders_yet": "No orders yet",
    "account.create_your_first_scent": "Create Your First Scent",
    "account.no_completed_orders_yet": "No completed orders yet",
    "account.saved_addresses": "Saved Addresses",
    "account.manage_your_delivery_addresses": "Manage your delivery addresses",
    "account.add_address": "Add Address",
    "account.edit_address": "Edit Address",
    "account.add_new_address": "Add New Address",
    "account.label_e_g_home_office": "Label (e.g., Home, Office)",
    "account.home": "Home",
    "account.address_line_1": "Address Line 1",
    "account.street_address": "Street address",
    "account.address_line_2": "Address Line 2",
    "account.apartment_suite_etc": "Apartment, suite, etc.",
    "account.city": "City",
    "account.dubai": "Dubai",
    "account.state_province": "State/Province",
    "account.postal_code": "Postal Code",
    "account.update_address": "Update Address",
    "account.save_address": "Save Address",
    "account.no_saved_addresses": "No saved addresses",
    "account.default": "Default",
    "account.set_default": "Set Default",
    "account.delete": "Delete",
    "account.download_invoices_for_your_orders": "Download invoices for your orders",
    "account.no_invoices_available_yet": "No invoices available yet",
    "account.invoices_are_generated_when_your_order_is_placed": "Invoices are generated when your order is placed",
    "account.view": "View",
    "account.print_save_pdf": "Print / Save PDF",
    "account.my_wishlist": "My Wishlist",
    "account.products_you_ve_saved_for_later": "Products you've saved for later.",
    "account.request_a_return": "Request a Return",
    "account.start_a_return_for_this_order": "Start a return for this order.",
    "account.we_couldn_t_load_this_order_please_open_it_again_from_the_orders_tab": "We couldn't load this order. Please open it again from the Orders tab.",
    "account.returns_can_only_be_requested_after_an_order_is_marked_as_delivered": "Returns can only be requested after an order is marked as delivered.",
    "account.a_return_request_has_already_been_submitted_for_this_order_only_one_return_request_is_allowed_per_order": "A return request has already been submitted for this order. Only one return request is allowed per order.",
    "account.this_order_is_no_longer_eligible_for_return_return_window_has_expired": "This order is no longer eligible for return (return window has expired).",
    "auth.hide_password": "Hide password",
    "auth.show_password": "Show password",
    "auth.reset_sent_to": "Password reset link sent to {email}",
    "auth.check_inbox": ". Please check your inbox and spam folder.",
    "account.cancel_confirmation": "Are you sure you want to cancel order {number}? This action cannot be undone.",
    "account.phone_digits": "{count}/{total} digits",
    "account.phone_invalid": "Please enter a valid phone number.",
    "account.status.new_order": "Order Placed",
    "account.status.in_production": "In Production",
    "account.status.qa_review": "Quality Check",
    "account.status.out_for_delivery": "Out for Delivery",
    "account.status.delivered": "Delivered",
    "account.status.return_requested": "Return Requested",
    "account.status.return_approved": "Return Approved",
    "account.status.returned": "Returned",
    "account.status.cancelled": "Cancelled",
    "account.status.rejected": "Rejected",
    "account.status.payment_pending": "Payment Pending",
    "auth.unexpected_error": "An unexpected error occurred. Please try again.",
    "account.unexpected_error": "An unexpected error occurred. Please try again.",
    "account.profile_active": "Active",
    "account.profile_inactive": "Inactive",
    "account.profile_suspended": "Suspended"
  },
  "ar": {
    "auth.please_enter_a_valid_email_address": "يرجى إدخال عنوان بريد إلكتروني صالح.",
    "auth.password_must_be_at_least_6_characters": "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.",
    "auth.full_name_is_required": "الاسم الكامل مطلوب",
    "auth.passwords_do_not_match": "كلمتا المرور غير متطابقتين",
    "auth.email_or_password_is_incorrect_please_check_your_credentials_and_try_again": "البريد الإلكتروني أو كلمة المرور غير صحيحة. يرجى التحقق والمحاولة مجددًا.",
    "auth.please_verify_your_email_address_before_signing_in": "يرجى تأكيد عنوان بريدك الإلكتروني قبل تسجيل الدخول.",
    "auth.login_failed": "تعذّر تسجيل الدخول",
    "auth.please_check_your_email_and_password": "يرجى التحقق من بريدك الإلكتروني وكلمة المرور.",
    "auth.welcome_back": "مرحبًا بعودتك!",
    "auth.you_have_successfully_logged_in": "تم تسجيل دخولك بنجاح.",
    "auth.this_email_is_already_registered_please_sign_in_instead": "هذا البريد الإلكتروني مسجّل بالفعل. يرجى تسجيل الدخول.",
    "auth.signup_failed": "تعذّر إنشاء الحساب",
    "auth.account_created": "تم إنشاء الحساب!",
    "auth.welcome_to_anaya_your_account_has_been_created_successfully": "مرحبًا بك في أنايا! تم إنشاء حسابك بنجاح.",
    "auth.google_sign_in_failed": "تعذّر تسجيل الدخول باستخدام Google",
    "auth.error": "خطأ",
    "auth.an_unexpected_error_occurred_please_try_again": "حدث خطأ غير متوقع. يرجى المحاولة مجددًا.",
    "auth.invalid_email": "بريد إلكتروني غير صالح",
    "auth.reset_link_sent": "تم إرسال رابط إعادة التعيين",
    "auth.check_your_email_for_a_password_reset_link": "تحقق من بريدك الإلكتروني للحصول على رابط إعادة تعيين كلمة المرور.",
    "auth.invalid_password": "كلمة مرور غير صالحة",
    "auth.passwords_don_t_match": "كلمتا المرور غير متطابقتين",
    "auth.please_make_sure_both_passwords_match": "يرجى التأكد من تطابق كلمتي المرور.",
    "auth.password_updated": "تم تحديث كلمة المرور",
    "auth.your_password_has_been_updated_successfully": "تم تحديث كلمة المرور بنجاح.",
    "auth.loading": "جارٍ التحميل...",
    "auth.back_to_home": "العودة إلى الرئيسية",
    "auth.anaya": "أنايا",
    "auth.reset_password": "إعادة تعيين كلمة المرور",
    "auth.enter_your_new_password_below": "أدخل كلمة المرور الجديدة أدناه",
    "auth.new_password": "كلمة المرور الجديدة",
    "auth.confirm_password": "تأكيد كلمة المرور",
    "auth.updating": "جارٍ التحديث...",
    "auth.update_password": "تحديث كلمة المرور",
    "auth.back_to_login": "العودة إلى تسجيل الدخول",
    "auth.forgot_password": "هل نسيت كلمة المرور؟",
    "auth.check_your_email_for_a_reset_link": "تحقق من بريدك الإلكتروني للحصول على رابط إعادة التعيين",
    "auth.enter_your_email_and_we_ll_send_you_a_reset_link": "أدخل بريدك الإلكتروني وسنرسل إليك رابط إعادة التعيين",
    "auth.email_address": "عنوان البريد الإلكتروني",
    "auth.sending": "جارٍ الإرسال...",
    "auth.send_reset_link": "إرسال رابط إعادة التعيين",
    "auth.welcome": "مرحبًا بك",
    "auth.sign_in_to_your_account_or_create_a_new_one": "سجّل الدخول إلى حسابك أو أنشئ حسابًا جديدًا",
    "auth.sign_in": "تسجيل الدخول",
    "auth.sign_up": "إنشاء حساب",
    "auth.email": "البريد الإلكتروني",
    "auth.password": "كلمة المرور",
    "auth.signing_in": "جارٍ تسجيل الدخول...",
    "auth.or_continue_with": "أو تابع باستخدام",
    "auth.sign_in_with_google": "تسجيل الدخول باستخدام Google",
    "auth.don_t_have_an_account": "ليس لديك حساب؟",
    "auth.full_name": "الاسم الكامل",
    "auth.john_doe": "الاسم الكامل",
    "auth.creating_account": "جارٍ إنشاء الحساب...",
    "auth.create_account": "إنشاء حساب",
    "auth.signing_up": "جارٍ إنشاء الحساب...",
    "auth.sign_up_with_google": "إنشاء حساب باستخدام Google",
    "auth.already_have_an_account": "لديك حساب بالفعل؟",
    "account.error": "خطأ",
    "account.verification_email_sent": "تم إرسال رسالة التأكيد",
    "account.please_check_your_inbox_and_click_the_verification_link": "يرجى التحقق من بريدك الوارد والنقر على رابط التأكيد.",
    "account.invalid_phone_number": "رقم هاتف غير صالح",
    "account.failed_to_update_profile": "تعذّر تحديث الملف الشخصي",
    "account.profile_updated": "تم تحديث الملف الشخصي",
    "account.your_profile_has_been_updated_successfully": "تم تحديث ملفك الشخصي بنجاح.",
    "account.failed_to_save_address": "تعذّر حفظ العنوان",
    "account.address_updated": "تم تحديث العنوان",
    "account.address_added": "تمت إضافة العنوان",
    "account.your_address_has_been_saved_successfully": "تم حفظ عنوانك بنجاح.",
    "account.failed_to_delete_address": "تعذّر حذف العنوان",
    "account.address_deleted": "تم حذف العنوان",
    "account.the_address_has_been_removed": "تمت إزالة العنوان.",
    "account.default_address_set": "تم تعيين العنوان الافتراضي",
    "account.this_address_will_be_used_for_new_orders": "سيُستخدم هذا العنوان للطلبات الجديدة.",
    "account.failed_to_cancel_order_please_contact_support": "تعذّر إلغاء الطلب. يرجى التواصل مع الدعم.",
    "account.cannot_cancel": "لا يمكن الإلغاء",
    "account.this_order_cannot_be_cancelled_it_may_have_already_been_processed": "لا يمكن إلغاء هذا الطلب. ربما بدأت معالجته بالفعل.",
    "account.order_cancelled": "تم إلغاء الطلب",
    "account.your_order_has_been_cancelled_successfully": "تم إلغاء طلبك بنجاح.",
    "account.failed_to_generate_invoice_please_try_again": "تعذّر إنشاء الفاتورة. يرجى المحاولة مجددًا.",
    "account.custom_perfume": "عطر مخصّص",
    "account.loading": "جارٍ التحميل...",
    "account.close_account_page": "إغلاق صفحة الحساب",
    "account.my_account": "حسابي",
    "account.sign_out": "تسجيل الخروج",
    "account.create_your_perfume": "ابتكر عطرك",
    "account.anaya_exclusive_collection": "مجموعة أنايا الحصرية",
    "account.profile": "الملف الشخصي",
    "account.orders": "الطلبات",
    "account.addresses": "العناوين",
    "account.invoices": "الفواتير",
    "account.wishlist": "قائمة الأمنيات",
    "account.returns": "المرتجعات",
    "account.profile_information": "معلومات الملف الشخصي",
    "account.manage_your_personal_details": "إدارة بياناتك الشخصية",
    "account.edit": "تعديل",
    "account.full_name": "الاسم الكامل",
    "account.your_full_name": "اسمك الكامل",
    "account.country": "الدولة",
    "account.select_country": "اختر الدولة",
    "account.phone_number": "رقم الهاتف",
    "account.save_changes": "حفظ التغييرات",
    "account.cancel": "إلغاء",
    "account.not_set": "غير محدّد",
    "account.email": "البريد الإلكتروني",
    "account.phone": "الهاتف",
    "account.status": "الحالة",
    "account.ticket_credits": "رصيد القسائم",
    "account.each_ticket_net_amount_paid_for_accessory": "كل قسيمة تعادل صافي المبلغ المدفوع للإكسسوار",
    "account.available_tickets": "القسائم المتاحة",
    "account.ticket": "قسيمة",
    "account.total_aed": "الإجمالي: AED",
    "account.redeem_at_checkout": "استخدمها عند إتمام الشراء",
    "account.1_ticket_per_item": "(قسيمة واحدة لكل منتج)",
    "account.hide_ticket_details": "إخفاء تفاصيل القسائم",
    "account.view_ticket_details": "عرض تفاصيل القسائم",
    "account.recent_transactions": "المعاملات الأخيرة",
    "account.1_ticket": " (قسيمة واحدة)",
    "account.accessory_purchase": "شراء إكسسوار",
    "account.ticket_redeemed": "تم استخدام القسيمة",
    "account.password": "كلمة المرور",
    "account.change_your_account_password": "تغيير كلمة مرور حسابك",
    "account.change_password": "تغيير كلمة المرور",
    "account.new_password": "كلمة المرور الجديدة",
    "account.enter_new_password_min_6_characters": "أدخل كلمة مرور جديدة (6 أحرف على الأقل)",
    "account.confirm_new_password": "أكّد كلمة المرور الجديدة",
    "account.invalid_password": "كلمة مرور غير صالحة",
    "account.password_must_be_at_least_6_characters": "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل",
    "account.passwords_don_t_match": "كلمتا المرور غير متطابقتين",
    "account.please_make_sure_both_passwords_match": "يرجى التأكد من تطابق كلمتي المرور",
    "account.password_updated": "تم تحديث كلمة المرور",
    "account.your_password_has_been_changed_successfully": "تم تغيير كلمة المرور بنجاح",
    "account.updating": "جارٍ التحديث...",
    "account.update_password": "تحديث كلمة المرور",
    "account.active_orders": "الطلبات الحالية",
    "account.track_your_current_orders": "تتبّع طلباتك الحالية",
    "account.placed_on": "تاريخ الطلب",
    "account.anaya_collection": "مجموعة أنايا",
    "account.your_ai_crafted_collection": "مجموعتك المصمّمة بالذكاء الاصطناعي",
    "account.code": "الرمز:",
    "account.view_details": "عرض التفاصيل",
    "account.reorder": "إعادة الطلب",
    "account.return": "إرجاع",
    "account.cancel_order": "إلغاء الطلب",
    "account.keep_order": "الاحتفاظ بالطلب",
    "account.order_history": "سجل الطلبات",
    "account.view_all_your_past_orders": "عرض جميع طلباتك السابقة",
    "account.no_orders_yet": "لا توجد طلبات بعد",
    "account.create_your_first_scent": "ابتكر عطرك الأول",
    "account.no_completed_orders_yet": "لا توجد طلبات مكتملة بعد",
    "account.saved_addresses": "العناوين المحفوظة",
    "account.manage_your_delivery_addresses": "إدارة عناوين التوصيل",
    "account.add_address": "إضافة عنوان",
    "account.edit_address": "تعديل العنوان",
    "account.add_new_address": "إضافة عنوان جديد",
    "account.label_e_g_home_office": "تسمية العنوان (مثل المنزل أو المكتب)",
    "account.home": "المنزل",
    "account.address_line_1": "سطر العنوان الأول",
    "account.street_address": "عنوان الشارع",
    "account.address_line_2": "سطر العنوان الثاني",
    "account.apartment_suite_etc": "الشقة، الجناح، إلخ.",
    "account.city": "المدينة",
    "account.dubai": "دبي",
    "account.state_province": "الولاية / المحافظة",
    "account.postal_code": "الرمز البريدي",
    "account.update_address": "تحديث العنوان",
    "account.save_address": "حفظ العنوان",
    "account.no_saved_addresses": "لا توجد عناوين محفوظة",
    "account.default": "افتراضي",
    "account.set_default": "تعيين كافتراضي",
    "account.delete": "حذف",
    "account.download_invoices_for_your_orders": "تنزيل فواتير طلباتك",
    "account.no_invoices_available_yet": "لا توجد فواتير متاحة بعد",
    "account.invoices_are_generated_when_your_order_is_placed": "تُنشأ الفواتير عند تقديم طلبك",
    "account.view": "عرض",
    "account.print_save_pdf": "طباعة / حفظ بصيغة PDF",
    "account.my_wishlist": "قائمة أمنياتي",
    "account.products_you_ve_saved_for_later": "المنتجات التي حفظتها لوقت لاحق.",
    "account.request_a_return": "طلب إرجاع",
    "account.start_a_return_for_this_order": "ابدأ طلب إرجاع لهذا الطلب.",
    "account.we_couldn_t_load_this_order_please_open_it_again_from_the_orders_tab": "تعذّر تحميل هذا الطلب. يرجى فتحه مجددًا من علامة تبويب الطلبات.",
    "account.returns_can_only_be_requested_after_an_order_is_marked_as_delivered": "لا يمكن طلب الإرجاع إلا بعد تسجيل الطلب كمُسلَّم.",
    "account.a_return_request_has_already_been_submitted_for_this_order_only_one_return_request_is_allowed_per_order": "تم تقديم طلب إرجاع لهذا الطلب بالفعل. يُسمح بطلب إرجاع واحد فقط لكل طلب.",
    "account.this_order_is_no_longer_eligible_for_return_return_window_has_expired": "لم يعد هذا الطلب مؤهّلًا للإرجاع (انتهت مهلة الإرجاع).",
    "auth.hide_password": "إخفاء كلمة المرور",
    "auth.show_password": "إظهار كلمة المرور",
    "auth.reset_sent_to": "تم إرسال رابط إعادة تعيين كلمة المرور إلى {email}",
    "auth.check_inbox": ". يرجى التحقق من البريد الوارد ومجلد الرسائل غير المرغوب فيها.",
    "account.cancel_confirmation": "هل أنت متأكد من إلغاء الطلب {number}؟ لا يمكن التراجع عن هذا الإجراء.",
    "account.phone_digits": "{count}/{total} أرقام",
    "account.phone_invalid": "يرجى إدخال رقم هاتف صالح.",
    "account.status.new_order": "تم تقديم الطلب",
    "account.status.in_production": "قيد التحضير",
    "account.status.qa_review": "فحص الجودة",
    "account.status.out_for_delivery": "قيد التوصيل",
    "account.status.delivered": "تم التسليم",
    "account.status.return_requested": "تم طلب الإرجاع",
    "account.status.return_approved": "تمت الموافقة على الإرجاع",
    "account.status.returned": "تم الإرجاع",
    "account.status.cancelled": "ملغى",
    "account.status.rejected": "مرفوض",
    "account.status.payment_pending": "بانتظار الدفع",
    "auth.unexpected_error": "حدث خطأ غير متوقع. يرجى المحاولة مجددًا.",
    "account.unexpected_error": "حدث خطأ غير متوقع. يرجى المحاولة مجددًا.",
    "account.profile_active": "نشط",
    "account.profile_inactive": "غير نشط",
    "account.profile_suspended": "موقوف"
  }
};
